import { Component } from '@angular/core';
import { Page, ProductSearchService } from '@spartacus/core';
import { PageLayoutService } from '@spartacus/storefront';
import { map, switchMap } from 'rxjs';

@Component({
  selector: 'plp-page-name',
  templateUrl: './plp-page-name.component.html',
  styleUrl: './plp-page-name.component.scss',
  standalone: false,
})
export class PlpPageNameComponent {
  templateName$ = this.pageLayoutService.page$.pipe(
    map((page: Page) => {
      return page.template;
    }),
  );

  pageName$ = this.templateName$.pipe(
    switchMap((template: any) => {
      return this.productSearchService.getResults().pipe(
        map((data: any) => {
          if (template === 'SearchResultsListPageTemplate' || template === 'SearchResultsGridPageTemplate') {
            return `"${data.freeTextSearch || ''}"`;
          }

          // Todo: O back-end ainda não manda o nome correto da category, apenas seu cod. então assim que o back passar a enviar o dado correto,
          // precisamos ajustar esse cod.
          // O CSF no breadcrumb default utiliza esse dado:  return (data && data?.breadcrumbs && data?.breadcrumbs[0]?.facetValueName) || '';

          return (data && data?.breadcrumbs && data?.breadcrumbs[0]?.facetValueName) || '';

          // const partiallyDecodedString = decodeURIComponent(
          //   window.location.pathname.split('/')[window.location.pathname.split('/').indexOf('c') - 1],
          // );
          // const fullyDecodedString = decodeURIComponent(partiallyDecodedString);
          // const formatingName = decodeURIComponent(fullyDecodedString);
          // return formatingName.replaceAll('-', ' ');
        }),
      );
    }),
  );

  constructor(
    private productSearchService: ProductSearchService,
    private pageLayoutService: PageLayoutService,
  ) {}
}
